export const IMAGE_STUDIO_DE = {
  // Header
  imageStudio: 'ImageStudio',
  generateImages: 'Bilder generieren',

  // Form
  promptLabel: 'Prompt',
  promptPlaceholder: 'Beschreibe das Bild, das du generieren möchtest...',
  modelPreset: 'Voreinstellung',
  modelFast: 'Vertex Imagen 4 Fast',
  modelNanoBananPro: 'Nano Banana Pro',
  aspectRatio: 'Seitenverhältnis',
  numberOfImages: 'Anzahl Bilder',
  charactersCount: '{count}/5000 Zeichen',
  showSettings: 'Einstellungen anzeigen',
  hideSettings: 'Einstellungen ausblenden',
  loadingOptions: 'Optionen werden geladen...',
  addFiles: 'Dateien hinzufügen',

  // Aspect ratios
  square: 'Quadrat (1:1)',
  landscape: 'Querformat (16:9)',
  portrait: 'Hochformat (9:16)',
  standard: 'Standard (4:3)',
  portraitStandard: 'Hochformat Standard (3:4)',

  // Gallery
  all: 'Alle',
  completedImages: 'Abgeschlossen',

  // Empty states
  noImages: 'Noch keine Bilder',
  noImagesDescription: 'Starte mit der Bildgenerierung, indem du unten einen Prompt eingibst',
  noGenerating: 'Keine laufenden Generierungen',
  noCompleted: 'Keine abgeschlossenen Bilder',

  // Card
  imageGenerationFailed: 'Generierung fehlgeschlagen',
  generationFailedTryAgain: 'Bitte versuche es erneut.',
  previewUnavailable: 'Vorschau nicht verfügbar',
  previewExpiredTitle: 'Vorschau-Link abgelaufen',
  previewExpiredDescription:
    'Diese Bild-URL ist abgelaufen. Generiere erneut für eine aktuelle Vorschau.',
  multipleImages: '+{count} weitere',

  // Preview modal
  imageDetails: 'Bilddetails',
  createdAt: 'Erstellt',
  tpromptUsed: 'TPrompt',
  tpromptDefault: 'Standard-Voreinstellung',

  // Status
  statusGenerating: 'Generiert',
  statusFinished: 'Abgeschlossen',
  statusError: 'Fehlgeschlagen',

  // Actions
  deleteAllOutdatedImages: 'Veraltete Platzhalter löschen ({count})',
  deleteOutdatedConfirmTitle: 'Veraltete Platzhalter löschen',
  deleteOutdatedConfirmMessage:
    'Möchten Sie {count} veraltete Bildkarte(n) löschen? Dadurch werden defekte Vorschau-Links aus der Galerie entfernt.',
  deleteConfirmTitle: 'Bild löschen',
  deleteConfirmMessage:
    'Möchten Sie dieses Bild wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',

  // Toast messages
  generationStarted: 'Bildgenerierung gestartet',
  imageGenerationCompleted: 'Bild erfolgreich generiert!',
  generationFailedToast: 'Bildgenerierung fehlgeschlagen',
  imageDeleted: 'Bild gelöscht',
  outdatedImagesDeleted: '{count} veraltete Platzhalterkarte(n) gelöscht.',
  outdatedImagesDeleteFailed: '{count} veraltete Karte(n) konnten nicht gelöscht werden.',
  downloadStarted: 'Bild wird heruntergeladen...',
  promptTooShort: 'Prompt muss mindestens 3 Zeichen haben',
  promptTooLong: 'Prompt darf maximal 5000 Zeichen haben',
  filesNotSupported: 'Dateianhänge werden im Image Studio noch nicht unterstützt.',

  // Time formatting
  justNow: 'Gerade eben',
  minutesAgo: 'vor {count} Min.'
}
